import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
import HtlAgnReductionEdit from "./HtlAgnReductionEdit";



import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12(
    $firmMainCode: String
    $firmSubCode: String
    $currentLocale: String
    $contIdSeq: Int!

  ) {
    tbl_cont_season_def(
      order_by: { firm_main_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        cont_id: { _eq: $contIdSeq }
        
      }
    ) {
      firm_main_code
      firm_sub_code
      id_seq
      cont_id
      season_id
      start_date
      end_date
      opt_1
    }
  }
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const GET_PER_DEFS = gql`
  query GetPerDefs($firmMainCode: String, 
                   $firmSubCode: String,
                   $contIdSeq: Int) {
    tbl_cont_per_def(where: {
      firm_main_code: { _eq: $firmMainCode }, 
      firm_sub_code: { _eq: $firmSubCode },
      cont_id: { _eq: $contIdSeq }
    },
    order_by: { id_seq: asc }
  ) {
      id_seq
      period
      start_date
      end_date
    }
  }
`;




const GET_PER_BASE = gql`
  query GetPerBase(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int
  ) {
    tbl_cont_per_base(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq }
      },
      order_by: { room_type: asc } 
    ) {   
      per_id
      room_type
      get_room_name {
        r_type_name
      }
      base_price
      period
    }
  }
`;


const GET_PER_RED = gql`
    query GetPerPer(
      $firmMainCode: String,
      $firmSubCode: String,
      $contIdSeq: Int
    ) {
      tbl_cont_per_per(
        where: {
          firm_main_code: { _eq: $firmMainCode },
          firm_sub_code: { _eq: $firmSubCode },
          cont_id: { _eq: $contIdSeq }
        },
        order_by: { id_seq: asc }
      ) {
        id_seq
        cont_id
        per_id
        period
        person
        person_type
        red_sup_type
        percent
        rooms
      }
    }
  `;



const GET_HTL_SEA = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    
  ) {
    tbl_htl_season(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
       
      }
    ) {
     
        id_seq
        start_date
        end_date
        desc
        active
       
    }
  }
`;


const GET_HTL_PER = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    $htlSeaIdSeq: Int
    
  ) {
    tbl_htl_period(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        sea_id_seq: { _eq: $htlSeaIdSeq }
       
      }
    ) {
     
        id_seq
        sea_id_seq
        period
        start_date
        end_date
        release
        min_stay
       
    }
  }
`;

const INSERT_HTL_PER_RECORDS_MUTATION = gql`
  mutation InsertHtlPerRecordsIntoContPer($records: [tbl_cont_per_def_insert_input!]!) {
    insert_tbl_cont_per_def(objects: $records) {
      affected_rows
    }
  }
`;

const GET_HTL_SEA2 = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    $htlSeaIdSeq: Int
    
  ) {
    tbl_htl_season(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        
       
      }
    ) {
     
        id_seq
        start_date
        end_date
        desc
        active
       
    }
  }
`;




const GET_TBL_CONT_PER_DEF = gql`
  query GetTblContPerDef(
    $firmMainCode: String,
    $firmSubCode: String,
    $contIdSeq: Int,
    $htlSeaIdSeq: Int,
    $perPeriod: String
  ) {
    tbl_cont_per_def(where: {
      firm_main_code: { _eq: $firmMainCode },
      firm_sub_code: { _eq: $firmSubCode },
      cont_id: { _eq: $contIdSeq },
      
      period: { _eq: $perPeriod }
    }) {
      id_seq
    }
  }
`;


const INSERT_TBL_CONT_PER_BASE_MUTATION = gql`
  mutation InsertTblContPerBase($records: [tbl_cont_per_per_insert_input!]!) {
    insert_tbl_cont_per_per(objects: $records) {
      affected_rows
    }
  }
`;



const UPDATE_BASE_PRICE = gql`
mutation UpdateContBasePrice(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
  $contSeaIdSeq: Int
  $basePeriod: String
  $roomType: String
  $basePrice: float8 
  
) {
  update_tbl_cont_per_base(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
      sea_id: { _eq: $contSeaIdSeq }
      period: { _eq: $basePeriod }
      room_type: { _eq: $roomType }
    },
    _set: {
     base_price: $basePrice,
     
    }
  ) {
    affected_rows
  }
}
`;


const UPDATE_PER_PER = gql`
mutation UpdateContPerPer(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String  
  $perPeriod: String
  $perId: Int
  $redIdSeq: Int
  $perPersent: Int
  


  
) {
  update_tbl_cont_per_per(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }         
      id_seq: { _eq: $redIdSeq }
      period: { _eq: $perPeriod }
      
    },
    _set: {
      percent: $perPersent,
        
    }
  ) {
    affected_rows
  }
}
`;

const INSERT_PER_PER = gql`
  mutation InsertContractPerPer(
    $redIdSeq: Int
    $firmMainCode: String
    $firmSubCode: String  
    $contIdSeq: Int  
    $perPeriod: String
    $perId: Int
      
    $perPersent: Int
    $perPerson: Int
    $perPersonType: String
    $perRedSupType: String
    $perRooms: String

   
  ) {
    insert_tbl_cont_per_per(
      objects: {
        id_seq: $redIdSeq ,
        firm_main_code: $firmMainCode,
        firm_sub_code:$firmSubCode,
        cont_id: $contIdSeq,   
        period: $perPeriod,
        per_id:  $perId,
        percent: $perPersent,
        person_type: $perPersonType,
        red_sup_type: $perRedSupType,
        rooms: $perRooms,
        person: $perPerson,

      }
    ) {
      affected_rows
    }
  }
`;


const GET_PER_PER = gql`
  query GetPerPer($firmMainCode: String, 
                   $firmSubCode: String,
                   $contIdSeq: Int,
                   $perPeriod: String,
                   $redIdSeq: Int,
                   
                   ) {
    tbl_cont_per_per(where: {
      firm_main_code: { _eq: $firmMainCode }, 
      firm_sub_code: { _eq: $firmSubCode },
      cont_id: { _eq: $contIdSeq },
      id_seq: { _eq: $redIdSeq },
      period: { _eq: $perPeriod },
    }) {
      id_seq
      firm_main_code
      firm_sub_code
      cont_id
      period
      per_id
      percent
      person_type
      red_sup_type
      person
      rooms
    }
  }
`;

const GET_HTL_PER_FOR_UPDATE = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    $contIdSeq: Int
    $contSeaIdSeq: Int
    $perPeriod: String
    
    
  ) {
    tbl_cont_per_def(where: {
      firm_main_code: { _eq: $firmMainCode }, 
      firm_sub_code: { _eq: $firmSubCode },
      cont_id: { _eq: $contIdSeq },
      id_seq: { _eq: $contSeaIdSeq },
      period: { _eq: $perPeriod },
       
      }
    ) {
     
        id_seq
       
       
    }
  }
`;










const HtlAgnSeaReduction = () => {
    const { users } = useContext(UserContext);
    const { firmcode, subfirmcode, usertype, userLang } = users;
    const { id_seq } = useParams();
    const {varCode4, setVarCode4} = useContext(ThemeContext);
    const {varCode3, setVarCode3} = useContext(ThemeContext);
    const {varCode5, setVarCode5} = useContext(ThemeContext);
    const {varCode6, setVarCode6} = useContext(ThemeContext);
    const [someCondition, setSomeCondition] = useState(false);
    const [redIdSeq2] = useState(1);
    const [perPeriod2, setPerPeriod2] = useState("A");
    
   
    
    const firmMainCode = firmcode;
    const firmSubCode = subfirmcode;
    const intl = useIntl();
    const currentLocale = userLang || localStorage.getItem('lang') || 'en';
  
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);
    const [activeTabS, setActiveTabS] = useState(9);
  
    const handleTabChange = (index) => {
      setActiveTab(index);
    };
  
    const handleTabChangeS = (index) => {
      setActiveTabS(index);
    };
  
    const { loading, error, data, refetch } = useQuery(GET_POST, {
      variables: { firmSubCode, firmMainCode, contIdSeq: varCode4 },
    });

    const { loading: contPerPeLoading, error: contPerPeError, data: contPerPeraData } = useQuery(GET_PER_PER, {
      variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: varCode4,redIdSeq: redIdSeq2, perPeriod: perPeriod2 },
    });
  
    const ownFirmMainCode = firmcode;
    const ownFirmSubCode = subfirmcode;
    const ownFirmSubType = usertype;
  
   // const [UpdateContract] = useMutation(UPDATE_CONT);
    const [InsertContractPerPer] = useMutation(INSERT_PER_PER);
    const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2);
    const [insertPerRecords] = useMutation(INSERT_HTL_PER_RECORDS_MUTATION);
   

    const [UpdateContBasePrice] = useMutation(UPDATE_BASE_PRICE);
    const [UpdateContPerPer] = useMutation(UPDATE_PER_PER);

    

   
   
   
   
    

    


    // useMutation'ı bileşen içinde kullanın
    
    
  
  
    const firmData = data && data.tbl_cont_season_def ? data.tbl_cont_season_def[0] : null;

    const firmData2 = contPerPeraData && contPerPeraData.tbl_cont_per_per ? contPerPeraData.tbl_cont_per_per[0] : null;
    
   

    const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.cont_id :"");
    const [contSeaIdSeq, setContSeaIdSeq] = useState(firmData ? firmData.id_seq :"");
    const [htlSeaIdSeq, setHtlSeaIdSeq] = useState(firmData ? firmData.season_id :"");
    const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
    const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());



   

    const [perPeriod, setPerPeriod] = useState(firmData2 ? firmData2.period :"");
    const [perId, setPerId] = useState(firmData2 ? firmData2.per_id :"");
    const [redIdSeq, setRedIdSeq] = useState(firmData2 ? firmData2.id_seq :"");    
    const [perPersent, setPerPersent] = useState(firmData2 ? firmData2.percent :"");
    const [perPerson, setPerPerson] = useState(firmData2 ? firmData2.person : '');
    const [perPersonType, setPerPersonType] = useState(firmData2 ? firmData2.person_type :"");
    const [perRedSupType, setPerRedSupType] = useState(firmData2 ? firmData2.red_sup_type :"");
    const [perRooms, setPerRooms] = useState(firmData2 ? firmData2.rooms :"");
    const [perPersent2, setPerPersent2] = useState(null);

    const [insertingData, setInsertingData] = useState(false);




    
   
   
    
   

   // <HtlAgnContractEdit contCurrency={currency} setContCurrency={setCurrency} />  

    
    
  
    console.log("Firm Data:", firmData);

    const { loading: htlseaLoading, error: htlseaError, data: htlseaData } = useQuery(GET_HTL_SEA, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode},
      });

      const { loading: htlperLoading, error: htlperError, data: htlperData } = useQuery(GET_HTL_PER, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, htlSeaIdSeq: htlSeaIdSeq},
      });

      const { loading: htlperroomLoading, error: htlperroomError, data: htlperroomData } = useQuery(GET_TBL_CONT_PER_DEF, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq, htlSeaIdSeq:htlSeaIdSeq, perPeriod:perPeriod },
      });


      const { loading: htlseaLoading2, error: htlseaError2, data: htlseaData2 } = useQuery(GET_HTL_SEA2, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode},
      });


      const { loading: perLoading, error: perError, data: perData, refetch: refetchPerPer2 } = useQuery(GET_PER_RED, {
        variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: varCode4 },
      });

      const { loading: defsLoading, error: defsError, data: defsData } = useQuery(GET_PER_DEFS, {
    variables: { firmMainCode, firmSubCode, contIdSeq: varCode4 },
  });

  const { loading: redLoading, error: redError, data: redData, refetch: refetchPerPer } = useQuery(GET_PER_RED, {
    variables: { firmMainCode, firmSubCode, contIdSeq: varCode4 },
  });


  const { loading: tblContPerDefLoading, error: tblContPerDefError, data: tblContPerDefData } = useQuery(GET_TBL_CONT_PER_DEF, {
    variables: {
      firmMainCode: firmMainCode,
      firmSubCode: firmSubCode,
      contIdSeq: contIdSeq,
      
      perPeriod: perPeriod,
    },
  });

  const [insertContPerBase] = useMutation(INSERT_TBL_CONT_PER_BASE_MUTATION);
   


      const [columns, setColumns] = useState([]);


     
      const flatRedData2 = redData?.tbl_cont_per_per?.map((item) => ({
        ...item,
        [`percent_${item.period}`]: item.percent,
      })) || []; 


    /*  const flatRedData = redData?.tbl_cont_per_per?.reduce((acc, item) => {
        const existingItem = acc.find((accItem) => 
          accItem.person === item.person && accItem.person_type === item.person_type
        );
    
        if (existingItem) {
          // Eğer aynı person ve person_type zaten varsa, percent'leri ekleyelim
          existingItem[`percent_${item.period}`] = item.percent;
        } else {
          // Yoksa yeni bir öğe ekleyelim
          const newItem = {
            person: item.person,
            person_type: item.person_type,
            [`percent_${item.period}`]: item.percent,
            // Diğer özellikleri de ekleyebilirsiniz
          };
          acc.push(newItem);
        }
    
        return acc;
      }, []); */

     /* calısan son

      const flatRedData = redData?.tbl_cont_per_per?.reduce((acc, item) => {
        const existingItem = acc.find((accItem) => 
          accItem.person === item.person && accItem.person_type === item.person_type 
          && accItem.red_sup_type === item.red_sup_type
        );
      
        if (existingItem) {
          // Eğer aynı person ve person_type zaten varsa, percent ve red_sup_type'ı ekleyelim
          existingItem[`percent_${item.period}`] = item.percent;
          existingItem.red_sup_type = item.red_sup_type; // Ekleme satırı
        } else {
          // Yoksa yeni bir öğe ekleyelim
          const newItem = {
            person: item.person,
            person_type: item.person_type,
            red_sup_type: item.red_sup_type, // Ekleme satırı
            [`percent_${item.period}`]: item.percent,
            // Diğer özellikleri de ekleyebilirsiniz
          };
          acc.push(newItem);
        }
      
        return acc;
      }, []); */

          // Başlık (header) için periodların yanına start_date ve end_date eklemek
    /*  const headerColumns = defsData.tbl_cont_per_def.map((def) => ({
        field: `percent_${def.period}`,
        header: `${def.period} (${def.start_date} - ${def.end_date})`,
        
      }));

      const flatRedData = redData?.tbl_cont_per_per?.reduce((acc, item) => {
        const existingItem = acc.find(
          (accItem) => accItem.person === item.person && accItem.person_type === item.person_type
        );
      
        if (existingItem) {
          const columnName = `percent_${item.period}`;
          existingItem[columnName] = item.percent !== undefined ? item.percent : 0;
        
      //    existingItem.red_sup_type = item.red_sup_type;
        } else {
          const newItem = {
            person: item.person,
            person_type: item.person_type,
            red_sup_type: item.red_sup_type,
            [`percent_${item.period}`]: item.percent,
            // Diğer özellikleri de ekleyebilirsiniz
          };
          acc.push(newItem);
        }
      
        return acc;
      }, []); */
      
      

  const cont_detail_tab = messages[currentLocale].cont_detail_tab;

  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);



 // const { loading: loadingPerDefs, data: perDefsData } = useQuery(GET_PER_DEFS);

 //const { loading: loadingPerDefs, data: perDefsData ,refetch: refetchPerDefs2 } = useQuery(GET_PER_DEFS);
  
 const { loading: loadingPerDefs, error: perDefError, data: perDefsData, refetch: refetchPerDefs2  } = useQuery(GET_PER_DEFS, {
    variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq},
  });
 
 //const { loading: loadingPerBase, data: perBaseData, refetch: refetchPerDefs  } = useQuery(GET_PER_BASE);
 const { loading: loadingPerBase, error: perBaseError, data: perBaseData, refetch: refetchPerDefs  } = useQuery(GET_PER_BASE, {
    variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq},
  });
  

  const handleInsertContPerBase = async () => {
    try {
      if (tblContPerDefLoading) {
        console.log("Loading...");
        return;
      }

      if (tblContPerDefError) {
        console.error("Error fetching tbl_cont_per_def data:", tblContPerDefError);
        console.error('Extra error information:', tblContPerDefError.graphQLErrors, tblContPerDefError.networkError);
        return;
      }

      const recordsToInsert = tblContPerDefData.tbl_cont_per_def.map((record) => ({
        per_id: record.id_seq,
        id_seq: redIdSeq,
        period: perPeriod,
        person: perPerson,
        red_sup_type: perRedSupType,
        rooms: perRooms,
        person_type: perPersonType,
        percent: perPersent,
        cont_id: contIdSeq,
        firm_main_code: firmMainCode,
        firm_sub_code: firmSubCode,
      }));

      const { data: insertData } = await insertContPerBase({
        variables: { records: recordsToInsert },
      });

      const affectedRows = insertData.insert_tbl_cont_per_per.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_cont_per_per.`);
      refetchPerPer(); 
      refetchPerPer2 ();   
      refetchPerDefs2();
      refetchPerDefs();
    } catch (error) {
      console.error('Error inserting into tbl_cont_per_per:', error);
      console.error('Extra error information:', error.graphQLErrors, error.networkError);
    } finally {
      setInsertingData(false);
    }
  };

  useEffect(() => {
    if (insertingData) {
      console.log("Already inserting data...");
      return;
    }

    // Diğer tetikleyici durumları perPersent2 

    setInsertingData(true);
    handleInsertContPerBase();

  }, [perPersent2]);

  useEffect(() => {
    if (!tblContPerDefLoading) {
      handleInsertContPerBase();
    }
  }, [tblContPerDefLoading]);


  

  const handlePerPereUpdate = () => {
    UpdateContPerPer({
      variables: {
        contIdSeq: contIdSeq,
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        perPeriod: perPeriod,
        redIdSeq: redIdSeq,
        perPersent: perPersent,
       

        
      },
    })
      .then(() => {
        window.alert("Contract Base updated successfully!");
      
      })
      .catch((error) => {
        console.error("Error updating Cont Base Price:", error);
      });
  };


  const handlePerPerinsert = () => {
    InsertContractPerPer({
     variables: {
      contIdSeq: contIdSeq,
      firmMainCode: firmMainCode,
      firmSubCode: firmSubCode,
      perPeriod: perPeriod,
      redIdSeq: redIdSeq,
      perPersent: perPersent,
      perId: perId,
      perPerson: perPerson,
      perRedSupType: perRedSupType,
      perRooms: perRooms,
      perPersonType: perPersonType,
      
      
     },
   })
     .then(() => {
       window.alert("Contract Season insert successfully!");
      
    
     })
     .catch((error) => {
       console.error("Error insert cont Season:", error);
       console.error('Mutation error:', error);
       console.error('Extra error information:', error.graphQLErrors, error.networkError);
       
     });
 };

  

  

  useEffect(() => {
    if (!loadingPerDefs && perDefsData) {
        const dynamicColumns = perDefsData.tbl_cont_per_def.map((def) => {
            const startDate = new Date(def.start_date);
            const endDate = new Date(def.end_date);

            const formattedStartDate = startDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric' });
            const formattedEndDate = endDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric' });

            return {
                field: def.period,
                header: (
                    <>
                        {def.period}
                        <br />
                        ({formattedStartDate} - {formattedEndDate})
                    </>
                ),
                body: (rowData) => (
                    <div>
                        {rowData['rooms']}
                    </div>
                ),
            };
        });

        // İlgili alanları tablo başlıklarına eklemek için spread operatörü (...) kullanılıyor.
        setTableColumns([
          { field: 'id_seq', header: 'ID' },  
          { field: 'rooms', header: 'Rooms' },
            { field: 'person_type', header: 'P Type' },
            { field: 'person', header: 'Pax' }, // Yeni alanlar ekleniyor
            { field: 'red_sup_type', header: 'Red Sup Type' }, // Yeni alanlar ekleniyor
            ...dynamicColumns,
        ]);
    }
}, [loadingPerDefs, perDefsData]);
  
useEffect(() => {
  if (!redLoading && redData) {
      const uniqueRoomTypes = [...new Set(redData.tbl_cont_per_per.map((item) => `${item.person}_${item.person_type}_${item.red_sup_type}_${item.id_seq}_${item.rooms}`))];

      const dynamicData = uniqueRoomTypes.map((key) => {
          const [person, person_type, red_sup_type, id_seq,rooms] = key.split('_');

          const rowData = {
            rooms: rooms,
              
              person: person,
              person_type: person_type,
              red_sup_type: red_sup_type,
              id_seq: id_seq,
              
             
          };

          redData.tbl_cont_per_per
              .filter((item) => `${item.person}_${item.person_type}_${item.red_sup_type}_${item.id_seq}_${item.rooms}` === key)
              .forEach((item) => {
                  rowData[item.period] = item.percent;
                  rowData.per_id = item.per_id;
              });

          return rowData;
      });

      setTableData(dynamicData);
  }
}, [redLoading, redData]);

    

    useEffect(() => {
        if (firmData) {  
               

          setContIdSeq(varCode4);
       //   setContIdSeq(firmData.cont_id);
          setContSeaIdSeq(firmData.id_seq);
          setHtlSeaIdSeq(firmData.season_id);
          setStartDate(new Date(firmData.start_date));
          setEndDate(new Date(firmData.end_date));
          refetch();  
          
    
        }
      }, [firmData]);

      useEffect(() => {
        if (firmData2) {  
               

          setPerPerson(firmData2.person);
          setPerPeriod(firmData2.period);
          setPerPersent(firmData2.percent);
        
          refetch();  
          
    
        }
      }, [firmData2]);

   
    

      const [selectedRowData, setSelectedRowData] = useState(null);
      const [displayDialog, setDisplayDialog] = useState(false);

      const onEditButtonClick = (rowData) => {
       // setSelectedRowData(rowData);
        setDisplayDialog(true);
        setVarCode3(contSeaIdSeq);
        
       
        // handleEditButtonClick'i çağırırken doğru parametreleri geçir
     //   handleEditButtonClick(rowData);
      };


    
    
     

      useEffect(() => {
        // varCode4 değiştiğinde yapılacak işlemler
        setContIdSeq(varCode4);
        setVarCode4(varCode4);
        setSomeCondition(true);
        
        
        // refetch fonksiyonunu çağırma koşullarına bağlı olarak
        if (someCondition) {
          refetch();
        }
      }, [varCode4, setContIdSeq, someCondition]);


          

      
      
      
      

    
      const handleDialogSave = () => {
       
        handlePerPerinsert();       
        setDisplayDialog(false);
        
      };
    
      const handleDialogCancel = () => {
        // İptal edildiğinde, seçili satır verilerini sıfırlayın ve dialog penceresini kapatın
        setSelectedRowData(null);
        setDisplayDialog(false); 
        refetchPerPer();        
        refetchPerPer2 ();  
       // refetch(); 
      };
      
      
      const [editingRowData, setEditingRowData] = useState(null);
        

        
        const onCellEditInit = (e) => {
            const { rowData } = e;
          
            // Eğer editingRowData zaten set edilmişse tekrar set etme
            if (!editingRowData) {
              setEditingRowData(rowData);
            }
          };
          useEffect(() => {
            // Bu useEffect, editingRowData state'i güncellendiğinde çalışacak
            if (editingRowData) {
              // Eğer editingRowData değeri mevcutsa, burada gerekli işlemleri gerçekleştirin
              console.log('editingRowData:', editingRowData);
            }
          }, [editingRowData]);
          
          const onCellEditComplete = (e) => {
            console.log('Hücre düzenleme tamamlandı:', e);
          
            const { field, value, rowData } = e;
          
            // Eğer rowData undefined ise, hatayı konsola yazdır ve işlemi sonlandır
            if (!rowData) {
              console.error('rowData is undefined!');
              return;
            }
          
            const personType = rowData['person_type'];
            const idSeq = rowData['id_seq'];
            const perId = rowData['per_id'];
            const perPerson = rowData['person'];
            const perRedSupType = rowData['red_sup_type'];
            const perRooms = rowData['rooms'];

            
          
            // Düzenlenen hücre bilgilerini konsola yazdırma
            console.log('Field:', field);
            console.log('Value:', value);
            console.log('Person Type:', personType);
            console.log('Red Id:', idSeq);
            console.log('Per Id:', perId);
            console.log('Rooms:', perRooms);
            console.log('Reduct:', perRedSupType);
            console.log('Person:', perPerson);

            
            setPerPersent(value);
            setRedIdSeq(idSeq);
            setPerPeriod(field);
            setPerPerson(perPerson);
            setPerRedSupType(perRedSupType);
            setPerRooms(perRooms);
            setPerPersonType(personType);
            setPerPersent2(field);
            
           
           // setPerId(perId);
            


           
            
           
          
            // Ilgili satırdaki veriyi kontrol et ve undefined değilse işlemleri gerçekleştir
            if (editingRowData) {
              console.log('Row Data:', editingRowData);
          
              // Örneğin, period, base_price, room_type gibi özel bilgilere erişebilirsiniz
              const period = editingRowData['period'];
              const basePrice = editingRowData['base_price'];
              const roomType = editingRowData['room_type'];
              console.log('Period:', period);
              console.log('Base Price:', basePrice);
              console.log('Room Type:', roomType);
             
          
              // Düzenleme tamamlandığında yapılacak işlemleri burada gerçekleştirin
           //   setEditingRowData(null); // Düzenleme tamamlandığında state'i temizle
            } else {
              console.error('editingRowData is undefined!');
            }
          };

          const onCellEditComplete2 = (e) => {
            console.log('Hücre düzenleme tamamlandı:', e);
            
            
          
            const { field, value, rowData } = e;
          
            // Eğer rowData undefined ise, hatayı konsola yazdır ve işlemi sonlandır
            if (!rowData) {
              console.error('rowData is undefined!');
              return;
            }
          
            const roomType = rowData['room_type'];
            const perId = rowData['per_id'];
            const roomName = rowData['r_type_name'];
            const RedId = rowData['id_seq'];
          
            // Düzenlenen hücre bilgilerini konsola yazdırma
            console.log('Field:', field);
            console.log('Value:', value);
            console.log('Room xType:', roomType);
            console.log('Per:', perId);
            console.log('name:', roomName);
            console.log('redid:', RedId);

            setVarCode5(RedId);
            setVarCode6(field);

            
            
            
            
           
            onEditButtonClick();
          //  setDisplayDialog(true);
          
            // Ilgili satırdaki veriyi kontrol et ve undefined değilse işlemleri gerçekleştir
            if (editingRowData) {
              console.log('Row Data:', editingRowData);
          
              // Örneğin, period, base_price, room_type gibi özel bilgilere erişebilirsiniz
              const period = editingRowData['period'];
              const basePrice = editingRowData['base_price'];
              const roomType = editingRowData['room_type'];
              
              console.log('Period:', period);
              console.log('Base Price:', basePrice);
              console.log('Room Type:', roomType);
          
              // Düzenleme tamamlandığında yapılacak işlemleri burada gerçekleştirin
           //   setEditingRowData(null); // Düzenleme tamamlandığında state'i temizle
            } else {
              console.error('editingRowData is undefined!');
            }
          };

          const RoomTypeEditor = (props) => {
            const { value, onValueChange, rowData } = props;
          
            return (
              <div>
                {value}
              </div>
            );
          };

          const TextEditor = (props) => {
            const { value, onValueChange, rowData } = props;
          
            const handleKeyPress = (e) => {
              if (e.keyCode === 13) {
                // Enter tuşuna basıldığında yapılacak işlemleri burada tanımlayabilirsiniz
                onCellEditComplete({ field: props.field, value: e.target.value, rowData });
            //    handleEditButtonClick({ field: props.field, value: e.target.value, rowData }); // Bu satırı ekleyin
              }
            };

            const handleKeyPress2 = (e) => {
                
                  // Enter tuşuna basıldığında yapılacak işlemleri burada tanımlayabilirsiniz
                  onCellEditComplete2({ field: props.field, value: null, rowData });
              //   handleEditButtonClick({ field: props.field, value: null, rowData }); // Bu satırı ekleyin
              
              };
              //<Button label="Edit" onClick={() => handleKeyPress2(rowData)} />
          
            return (
                <div className="flex h-2 items-center">
                <InputText
                  value={value}
                  prefix="%"
                  onChange={(e) => {
                    if (onValueChange) {
                      onValueChange(e.target.value);
                    }
                  }}
                  onKeyDown={handleKeyPress}
                  className="w-3/4 mr-2 p-0"
                />
                <button
                  onClick={() => handleKeyPress2(rowData)}
                  className="cursor-pointer ml-2 flex items-center justify-start"
                >
                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
              <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
               </svg>
                </button>
              </div>
            );
          };
       

           
  
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;
  
    return (
        <>
         <div>
  

  <DataTable
value={tableData}
frozenHeader
scrollable scrollHeight="450px" loading={loading}
showGridlines
stripedRows="true"
editMode="cell"
size={"small"}
onCellEditComplete={onCellEditComplete}
footerColumnGroup={"footerGroup"}
>
{tableColumns.map((column) => (
 <Column
   key={column.field}
   editor={column.field === 'rooms' ? (props) => <RoomTypeEditor {...props} /> : (props) => <TextEditor {...props} />}
   field={column.field}
   className="text-sm font-semibold text-right"  
   header={<span className="text-sm text-center font-semibold text-gray-900">{column.header}</span>}
   body={(rowData) => {
     if (column.field === 'rooms') {
       return (
         <div>
           {rowData['rooms']}
         </div>
       );
     } else {
       // Diğer kolonlar için normal içerik
       return <div>{rowData[column.field]}</div>;
     }
   }}
   style={{
     textAlign: 'left',
     width: column.field === 'rooms' ? '25rem' : column.field === 'id_seq' ? '5rem' : column.field === 'person_type' ? '7rem' : column.field === 'person' ? '7rem' : '10rem', // Genişlik ayarı
     fontWeight: column.field === 'rooms' ? 'bold' : 'Light', // Bold stil
   }}
 />
))}
</DataTable>

   {/* Dialog penceresi */}
   <Dialog header="Edit Cell" visible={displayDialog} style={{ width: '50vw' }} onHide={handleDialogCancel}>
   
       <div>

        <HtlAgnReductionEdit/>
      
         
         {/* ... Diğer bilgiler ... */}


         {/* Burada inputlar veya uygun form elemanları ekleyebilirsiniz */}
         
         <Button label="Save" onClick={handleDialogSave} />
         <Button label="Cancel" onClick={handleDialogCancel} />
       </div>
     
   </Dialog>

   <Button label="New" onClick={onEditButtonClick} />
 </div>
 
        
      
          
      
          
        </>
      );
      
  };
  
  export default HtlAgnSeaReduction;

  /*
  <div>
      <DataTable value={tableData} frozenHeader scrollable showGridlines editMode="cell" onCellEditComplete={onCellEditComplete}  onCellEditInit={onCellEditInit} >
        {tableColumns.map(column => (
          <Column key={column.field} editor={(props) => textEditor(props)} field={column.field} header={column.header} />
        ))}
      </DataTable>
    </div>
    <DataTable
  value={tableData}
  editMode="cell"
 
>
  {tableColumns.map((column) => (
    <Column
      key={column.field}
      field={column.field}
      header={column.header}
      editor={textEditor}
    />
  ))}
</DataTable> 

    <DataTable
       value={tableData}
        frozenHeader
         scrollable 
         showGridlines 
         editMode="cell" 
         onCellEditComplete={onCellEditComplete}
         >
        {tableColumns.map((column) => (
          <Column
            key={column.field}
            editor={(props) => textEditor(props)}
            field={column.field}
            className="text-sm text-left"  
         //   header={column.header}
            header={<span className="text-base font-semibold text-gray-900">{column.header}</span>}
            style={{ textAlign: 'left', width: '10rem' }}
          />
        ))}
      </DataTable>


yeniler



   <DataTable value={flatRedData} scrollable scrollHeight="200px">
      
      {defsData.tbl_cont_per_def.map((def) => (
        <Column key={def.period} field={`percent_${def.period}`} header={`Percent - ${def.period}`} />
      ))}
      <Column field="person" header="Person" />
      <Column field="person_type" header="Person Type" />
      <Column field="red_sup_type" header="Reduction Type" />
    </DataTable>



      <div>
      {perLoading && <p>Loading...</p>}
      {perError && <p>Error: {perError.message}</p>}
      {perData && perData.tbl_cont_per_per && (
        <DataTable value={data.tbl_cont_per_per}>
          <Column field="period" header="Period" />

          {perData.tbl_cont_per_per.map((item) => (
            <Column key={item.period} field={`percent_${item.period}`} header={`Percent - ${item.period}`} />
          ))}
        </DataTable>
      )}
    </div>

    <div>
      {defsLoading || redLoading ? (
        <p>Loading...</p>
      ) : defsError || redError ? (
        <p>Error: {defsError ? defsError.message : redError.message}</p>
      ) : defsData && redData && defsData.tbl_cont_per_def && redData.tbl_cont_per_per ? (
        <DataTable value={redData.tbl_cont_per_per}>
          <Column field="period" header="Period" />

          {defsData.tbl_cont_per_def.map((def) => (
            <Column key={def.period} field={`percent_${def.persent}`} header={`Percent - ${def.period}`} />
          ))}

          <Column field="person" header="Person" />
          <Column field="person_type" header="Person Type" />
          <Column field="red_sup_type" header="Reduction Type" />
        </DataTable>
      ) : null}
    </div>
    <div>
      {defsLoading || redLoading ? (
        <p>Loading...</p>
      ) : defsError || redError ? (
        <p>Error: {defsError ? defsError.message : redError.message}</p>
      ) : defsData && redData && defsData.tbl_cont_per_def && redData.tbl_cont_per_per ? (
        <DataTable value={defsData.tbl_cont_per_def}>
          <Column field="period" header="Period" />

          <Column field={`percent`} header={`Percent`} />

          {defsData.tbl_cont_per_def.map((def) => (
            <Column key={def.period} field={`percent.${def.percent}`} header={`Percent - ${def.percent}`} />
          ))}

          <Column field="person" header="Person" />
          <Column field="person_type" header="Person Type" />
          <Column field="red_sup_type" header="Reduction Type" />
        </DataTable>
      ) : null}
    </div>


     <DataTable value={mergedData}>
    <Column field="person" header="Person" />
    <Column field="person_type" header="Person Type" />
    <Column field="red_sup_type" header="Reduction Type" />
    {headers.map(header => (
      <Column key={header.field} field={header.field} header={header.header} />
    ))}
  </DataTable>


  
      
      */

  /*
    <Fieldset>



            
            <div className="flex">
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Cont Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={contIdSeq}
                  onValueChange={(e) => setContIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Cont Sea Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={contSeaIdSeq}
                  onValueChange={(e) => setContSeaIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Season Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={htlSeaIdSeq}
                  onValueChange={(e) => setHtlSeaIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>

                 <button
  className={`bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md ${
    contSeaIdSeq ? 'cursor-not-allowed opacity-50' : ''
  }`}
  onClick={contSeaIdSeq ? null : handleUpdateIdSeq}
  disabled={!!contSeaIdSeq}
>
  {contSeaIdSeq ? 'Sezon Tanımlanmıs' : 'Yeni sezon'}
</button>

<button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleInsertTempRecords}
      >
        {"cont_new_button"}
      </button>

      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleInsertBaseRecords}
      >
        {"cont_base_button"}
      </button>

    

            </div>
            
         

          </Fieldset>*/


      
  